import { Injectable, inject } from '@angular/core';
import { ApiConfigService } from '../api/api-config.service';
import { EnvironmentInfo } from '../../layout/app-shell/models/environment-info.model';

/**
 * Resolve o ambiente atual (Produção/Homologação/Desenvolvimento) a partir
 * de ApiConfigService.baseUrl — nunca fixo no template (EnvironmentBadge).
 * apiUrl é definido em build-time (src/environments/environment.*.ts) e não
 * muda durante a execução da SPA, então não há necessidade de signal aqui.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private readonly api = inject(ApiConfigService);

  readonly current: EnvironmentInfo = this.resolve(this.api.baseUrl);

  private resolve(apiUrl: string): EnvironmentInfo {
    if (apiUrl.includes('api.compleet.com.br')) {
      return { label: 'Produção', tone: 'success', production: true };
    }
    if (apiUrl.includes('api-hmg.compleet.com.br')) {
      return { label: 'Homologação', tone: 'warning', production: false };
    }
    return { label: 'Desenvolvimento', tone: 'info', production: false };
  }
}
